// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__257Mb","title":"ClientReferral_title__1BEtH","itemText":"ClientReferral_itemText__1A7dE"};